module.exports = __webpack_public_path__ + "img/img4.dae8b6d1.png";